import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Sticky "next page" CTA strip used at the bottom of every internal page.
 *  Pass either `to` (internal route) or `href` (external URL — opens in a new tab). */
export default function NextPageCta({ to, href, label, sub }) {
  const commonClass =
    "group block border-2 border-[#0B1215] bg-[#F8F9FA] hover:bg-[#0B1215] hover:text-[#F8F9FA] transition-colors p-8 sm:p-10";
  const inner = (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
      <div>
        <div className="font-mono-label text-[#FF5A36] mb-3">· NEXT</div>
        <h3 className="font-display text-3xl sm:text-4xl tracking-tighter leading-tight">{label}</h3>
        {sub && <p className="text-sm mt-2 opacity-70 max-w-md">{sub}</p>}
      </div>
      <ArrowRight
        size={48}
        strokeWidth={1.2}
        className="group-hover:translate-x-2 transition-transform shrink-0"
      />
    </div>
  );
  return (
    <section className="py-16 sm:py-20 bg-[#E9ECEF] border-t border-[#0B1215]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {href ? (
          <a href={href} target="_blank" rel="noopener noreferrer" className={commonClass} data-testid="next-page-cta">
            {inner}
          </a>
        ) : (
          <Link to={to} className={commonClass} data-testid="next-page-cta">
            {inner}
          </Link>
        )}
      </div>
    </section>
  );
}
